import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Methodology from '../components/Methodology';
import Team from '../components/Team';
import Benefits from '../components/Benefits';
import Stats from '../components/Stats';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <Hero />
      <Stats />
      <About />
      <Services />
      <Methodology />
      <Benefits />
      <Team />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;